import { createMagicDoorContext } from '~/contexts/utils';
import { DebugRepository } from '~/repositories/debugRepository';
import type { PlaidFailed } from '~/repositories/debugRepository';

const repo = new DebugRepository();

export const [DebugProvider, useDebug] = createMagicDoorContext('Debug', () => {
  const setPlaidStatusDebug = async (plaidId: string, status: 'settled' | 'failed' | 'returned', payload?: PlaidFailed) => {
    try {
      if (status === 'settled') {
        await repo.setPlaidStatusSettled(plaidId);
      } else if (status === 'failed' && payload) {
        await repo.setPlaidStatusFailed(plaidId, payload);
      } else if (status === 'returned') {
        await repo.setPlaidStatusReturned(plaidId);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    setPlaidStatusDebug,
  };
});
